const DataLayerManager = (() => {
    window.dataLayer = window.dataLayer || [];

    const events = {
        beginCheckout: "begin_checkout",
        addPaymentInfo: "add_payment_info",
        addShippingInfo: "add_shipping_info",
        addToCart: "add_to_cart",
        purchase: "purchase",
        selectItem: "select_item",
        viewItem: "view_item",
        viewItemList: "view_item_list"
    };

    const trigger = (eventName, ecommerceModel) => {
        window.dataLayer.push({
            event: eventName,
            ecommerce: ecommerceModel
        });
    }
    
    const getLatestEvent = (eventName = "") => {
        const matches = eventName ? window.dataLayer.filter(x => x.event === eventName) : window.dataLayer;

        return matches.length ? matches[matches.length - 1] : null;
    }

    return {
        events,
        trigger,
        getLatestEvent
    };
})();